// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminSeed = (client) => ({
    /**
     * `GET /admin/seed/status`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSeedStatusRetrieve
     * @source apps/backend/src/api/admin/seed/status/route.ts
     */
    listStatus: (query, headers) => client.fetch("/admin/seed/status", { method: "GET", query, headers }),
    /**
     * `POST /admin/seed/start`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSeedStartCreate
     * @source apps/backend/src/api/admin/seed/start/route.ts
     */
    start: (body, query, headers) => client.fetch("/admin/seed/start", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=seed.js.map